export type ActionKey = 'Slėptis' | 'Bėgti' | 'Įjungti žibintuvėlį' | 'Nejudėti';

export interface Room {
  id: number;
  name: string;
  description: string;
  correctAction: ActionKey;
  isVictory?: boolean;
  jumpscare: {
    imageUrl: string;
    text: string;
  };
  atmosphere: string;
  roomImageUrl: string;
  roomImageAlt: string;
}

export const ACTIONS: {key: ActionKey;label: string;emoji: string;}[] = [
{ key: 'Slėptis', label: 'Slėptis', emoji: '🙈' },
{ key: 'Bėgti', label: 'Bėgti', emoji: '🏃' },
{ key: 'Įjungti žibintuvėlį', label: 'Įjungti žibintuvėlį', emoji: '🔦' },
{ key: 'Nejudėti', label: 'Nejudėti', emoji: '🧍' }];


export const ROOMS_POOL: Room[] = [
{
  id: 1,
  name: 'Vorų kambarys',
  description: 'Tu įžengei į kambarį, pilną milžiniškų vorų. Nejudėk. Bet koks judesys atkreips jų dėmesį.',
  correctAction: 'Nejudėti',
  jumpscare: {
    imageUrl: 'https://images.unsplash.com/photo-1508193638397-1c4234db14d8?w=1200&q=95',
    text: 'VORAI TAVE APGAUBĖ!!!'
  },
  atmosphere: 'Tinklai visur. Kažkas juda tamsoje.',
  roomImageUrl: 'https://images.unsplash.com/photo-1734670045445-dc1b0d650e00',
  roomImageAlt: 'Tamsus kambarys pilnas milžiniškų vorų tinklų, baisus apšvietimas'
},
{
  id: 2,
  name: 'Kraujuojanti operacinė',
  description: 'Ant stalo kažkas dar kvėpuoja. Chirurgas atsisuka į tave. Apsimesk negyvu.',
  correctAction: 'Nejudėti',
  jumpscare: {
    imageUrl: 'https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=1200&q=95',
    text: 'CHIRURGAS TAVE PAMATĖ!!!'
  },
  atmosphere: 'Kraujas ant grindų. Peiliai blizga.',
  roomImageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_133492485-1772291201103.png",
  roomImageAlt: 'Apleista operacinė su krauju ant grindų ir chirurginiais instrumentais'
},
{
  id: 3,
  name: 'Manekenų salė',
  description: 'Visi manekenai žiūri į tave. Nusisukus jie priartėja.',
  correctAction: 'Nejudėti',
  jumpscare: {
    imageUrl: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=1200&q=95',
    text: 'MANEKENAI TAVE APSUPO!!!'
  },
  atmosphere: 'Jie stovi pernelyg arti. Stiklinės akys.',
  roomImageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_13bebdc72-1772101930358.png",
  roomImageAlt: 'Tamsus parduotuvės sandėlis su manekenais stovinčiais eilėmis'
},
{
  id: 4,
  name: 'Klouno kambarys',
  description: 'Klounas nemėgsta akių kontakto. Nenuleisk nuo jo akių.',
  correctAction: 'Nejudėti',
  jumpscare: {
    imageUrl: 'https://images.unsplash.com/photo-1509248961158-e54f6934749c?w=1200&q=95',
    text: 'KLOUNAS TAVE SUGAVO!!!'
  },
  atmosphere: 'Girdisi juokas. Jis artėja.',
  roomImageUrl: "https://images.unsplash.com/photo-1662981385473-4c49e5e00fdf",
  roomImageAlt: 'Tamsus kambarys su klouno makiažu ir baisiu apšvietimu'
},
{
  id: 5,
  name: 'Veidrodžių koridorius',
  description: 'Vienas tavo atspindys nesišypso. Jokiu būdu nežiūrėk jam į akis.',
  correctAction: 'Bėgti',
  jumpscare: {
    imageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_13467ea39-1776455244478.png",
    text: 'ATSPINDYS TAVE PRARIJO!!!'
  },
  atmosphere: 'Veidrodžiai kinta. Atspindys juda.',
  roomImageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_18b4d20e7-1774367932663.png",
  roomImageAlt: 'Koridorius su begaliniais veidrodžiais ir mirgančiu apšvietimu'
},
{
  id: 6,
  name: 'Skenduolių kambarys',
  description: 'Vanduo kyla. Girdisi beldimas iš po paviršiaus.',
  correctAction: 'Bėgti',
  jumpscare: {
    imageUrl: "https://images.unsplash.com/photo-1607710040695-167154036acc",
    text: 'SKENDUOLIAI TAVE ĮTRAUKĖ!!!'
  },
  atmosphere: 'Vanduo šaltas. Pirštai griebia.',
  roomImageUrl: "https://images.unsplash.com/photo-1697767330571-6eb8bfd528ab",
  roomImageAlt: 'Tamsus rūsys su kylančiu vandeniu ir mirgančia šviesa'
},
{
  id: 7,
  name: 'Lėlių vaikų kambarys',
  description: 'Viena lėlė pradėjo verkti. Jei ji nustos – bėk.',
  correctAction: 'Bėgti',
  jumpscare: {
    imageUrl: "https://images.unsplash.com/photo-1577655190993-bf0ce8d6b1ee",
    text: 'LĖLĖ NUSTOJO VERKTI... BĖGK!!!'
  },
  atmosphere: 'Verkimas nutyla. Kažkas pajudėjo.',
  roomImageUrl: 'https://img.rocket.new/generatedImages/rocket_gen_img_19ec84a50-1768633227849.png',
  roomImageAlt: 'Apleistas vaikų kambarys su senomis lėlėmis ir dulkėtais žaislais'
},
{
  id: 8,
  name: 'Mėsininko šaldytuvas',
  description: 'Kažkas sunkiai kvėpuoja už pakabintos mėsos.',
  correctAction: 'Slėptis',
  jumpscare: {
    imageUrl: 'https://images.unsplash.com/photo-1578328819058-b69f3a3b0f6b?w=1200&q=95',
    text: 'MĖSININKAS TAVE RADO!!!'
  },
  atmosphere: 'Šaltis. Kvapas. Žingsniai artėja.',
  roomImageUrl: 'https://images.unsplash.com/photo-1604528148834-ae31241bda33',
  roomImageAlt: 'Tamsus šaldytuvas su pakabinta mėsa ir silpna raudona šviesa'
},
{
  id: 9,
  name: 'Tamsos kambarys',
  description: 'Užgeso šviesa. Kažkas stovi visai šalia tavęs.',
  correctAction: 'Įjungti žibintuvėlį',
  jumpscare: {
    imageUrl: 'https://images.unsplash.com/photo-1519074069444-1ba4fff66d16?w=1200&q=95',
    text: 'TAMSA TAVE PRARIJO!!!'
  },
  atmosphere: 'Absoliuti tamsa. Kažkas liečia.',
  roomImageUrl: '',
  roomImageAlt: 'Pitch black darkness'
},
{
  id: 10,
  name: 'Grandinių rūsys',
  description: 'Išgirdai, kaip viena grandinė nutrūko.',
  correctAction: 'Slėptis',
  jumpscare: {
    imageUrl: "https://images.unsplash.com/photo-1585238399459-3b2c67679408",
    text: 'GRANDINĖS TAVE SURIŠO!!!'
  },
  atmosphere: 'Metalas skamba. Kažkas laisvas.',
  roomImageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_133492485-1772291201103.png",
  roomImageAlt: 'Tamsus rūsys su grandinėmis ir drėgnomis sienomis'
},
{
  id: 11,
  name: 'Raganos trobelė',
  description: 'Katilas pradėjo virti. Ragana jau žino tavo vardą.',
  correctAction: 'Slėptis',
  jumpscare: {
    imageUrl: 'https://images.unsplash.com/photo-1509557965875-b88c97052f0e?w=1200&q=95',
    text: 'RAGANA TAVE PAMATĖ!!!'
  },
  atmosphere: 'Dūmai. Žolelių kvapas. Kažkas šnabžda.',
  roomImageUrl: "https://images.unsplash.com/photo-1554467856-dc70c4f9d1f2",
  roomImageAlt: 'Tamsus miškas su raganos trobelės šviesa ir dūmais'
},
{
  id: 12,
  name: 'Kirmėlių lizdas',
  description: 'Grindys juda. Po tavo kojomis tūkstančiai gyvų padarų.',
  correctAction: 'Nejudėti',
  jumpscare: {
    imageUrl: 'https://images.unsplash.com/photo-1508193638397-1c4234db14d8?w=1200&q=95',
    text: 'KIRMĖLĖS TAVE APGAUBĖ!!!'
  },
  atmosphere: 'Šliaužimas. Grindys pulsuoja.',
  roomImageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1e3bb3591-1785517750864.png",
  roomImageAlt: 'Tamsus kambarys su judančiomis grindimis ir baisiu apšvietimu'
},
{
  id: 13,
  name: 'Kankinimų kamera',
  description: 'Kažkas prašo pagalbos. Tai spąstai.',
  correctAction: 'Nejudėti',
  jumpscare: {
    imageUrl: 'https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=1200&q=95',
    text: 'SPĄSTAI UŽSITRENKĖ!!!'
  },
  atmosphere: 'Metalas. Kraujas. Riksmai.',
  roomImageUrl: 'https://images.unsplash.com/photo-1597224828983-3573aaabd32e',
  roomImageAlt: 'Tamsus rūsys su kankinimų įrankiais ir raudona šviesa'
},
{
  id: 14,
  name: 'Koridorius be galo',
  description: 'Eini jau penkias minutes, bet durys vis tolsta.',
  correctAction: 'Bėgti',
  jumpscare: {
    imageUrl: "https://images.unsplash.com/photo-1670263966494-af7713418757",
    text: 'KORIDORIUS TAVE PRARIJO!!!'
  },
  atmosphere: 'Aidai. Žingsniai. Niekada nesibaigia.',
  roomImageUrl: 'https://img.rocket.new/generatedImages/rocket_gen_img_16563a44c-1772775749857.png',
  roomImageAlt: 'Begalinis tamsus koridorius su mirgančiomis žvakėmis'
},
{
  id: 15,
  name: 'Apleista mokykla',
  description: 'Skamba skambutis. Iš klasių pradeda eiti vaikai.',
  correctAction: 'Slėptis',
  jumpscare: {
    imageUrl: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=1200&q=95',
    text: 'VAIKAI TAVE RADO!!!'
  },
  atmosphere: 'Kreida. Dulkės. Juokas be džiaugsmo.',
  roomImageUrl: 'https://images.unsplash.com/photo-1528664566762-123938271a87',
  roomImageAlt: 'Apleista mokyklos klasė su dulkėtomis kėdėmis ir suolais'
},
{
  id: 16,
  name: 'Demono koplyčia',
  description: 'Žvakės užsidega pačios. Už tavęs kažkas sušnabžda tavo vardą.',
  correctAction: 'Nejudėti',
  jumpscare: {
    imageUrl: 'https://images.unsplash.com/photo-1509248961158-e54f6934749c?w=1200&q=95',
    text: 'DEMONAS TAVE PAMATĖ!!!'
  },
  atmosphere: 'Šventoji ugnis. Tamsus ritualas.',
  roomImageUrl: "https://images.unsplash.com/photo-1693335919983-987f8f74cc35",
  roomImageAlt: 'Tamsus koplyčios interjeras su žvakėmis ir baisiu apšvietimu'
},
{
  id: 17,
  name: 'Liftas į niekur',
  description: 'Liftas leidžiasi vis giliau. Mygtukai nebeveikia.',
  correctAction: 'Bėgti',
  jumpscare: {
    imageUrl: "https://images.unsplash.com/photo-1585238399459-3b2c67679408",
    text: 'LIFTAS SUSTOJO AMŽIAMS!!!'
  },
  atmosphere: 'Metalas girgžda. Tamsa gilėja.',
  roomImageUrl: "https://images.unsplash.com/photo-1714317559964-498c611e2c0c",
  roomImageAlt: 'Senas liftas su mirgančia šviesa ir rūdijančiomis sienomis'
},
{
  id: 18,
  name: 'Raudonasis koridorius',
  description: 'Sienomis teka kraujas. Girdisi bėgimo garsai – jie artėja.',
  correctAction: 'Bėgti',
  jumpscare: {
    imageUrl: 'https://images.unsplash.com/photo-1625952925392-2d6ae19471a2?w=1200&q=95',
    text: 'JIE TAVE PASIVIJO!!!'
  },
  atmosphere: 'Kraujas. Bėgimas. Artėja.',
  roomImageUrl: 'https://images.unsplash.com/photo-1654619137041-ac3eafeaaf4a',
  roomImageAlt: 'Tamsus koridorius su raudonomis sienomis ir krauju'
},
{
  id: 19,
  name: 'Monstro urvas',
  description: 'Kažkas kvėpuoja tamsoje. Jis medžioja pagal garsą.',
  correctAction: 'Nejudėti',
  jumpscare: {
    imageUrl: 'https://images.unsplash.com/photo-1519074069444-1ba4fff66d16?w=1200&q=95',
    text: 'MONSTRAS TAVE RADO!!!'
  },
  atmosphere: 'Kvėpavimas. Šiluma. Jis čia.',
  roomImageUrl: "https://images.unsplash.com/photo-1671527330550-bc44a39cf902",
  roomImageAlt: 'Tamsus urvas su tamsoje kvėpuojančiu padarų siluetu ir baisiu apšvietimu'
}];


// The final victory room — always last
export const VICTORY_ROOM: Room = {
  id: 20,
  name: 'Paskutinis kambarys',
  description: 'Durys užsitrenkė. Užsidega užrašas: "Sveikiname. Tu išgyvenai... kol kas."',
  correctAction: 'Slėptis',
  isVictory: true,
  jumpscare: {
    imageUrl: 'https://images.unsplash.com/photo-1611068830332-751f2d970597?w=1200&q=95',
    text: 'PASKUTINIS KAMBARYS!!!'
  },
  atmosphere: 'Paskutinis kambarys. Paskutinis šansas.',
  roomImageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_162223582-1773084793465.png",
  roomImageAlt: 'Paskutinis tamsus kambarys su užsitrenktomis durimis'
};

// Fisher-Yates shuffle
function shuffleArray<T>(arr: T[]): T[] {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

// Returns 9 random non-repeating rooms + victory room at end (10 total)
export function buildRoomSequence(): Room[] {
  const shuffled = shuffleArray(ROOMS_POOL);
  const selected = shuffled.slice(0, 9);
  return [...selected, VICTORY_ROOM];
}